// i18n area 'system' — locale es-MX (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da system.es-ES.ts e sovrascrive SOLO le chiavi
// che il messicano scrive davvero in un altro modo.
// DA RIVEDERE DA MADRELINGUA: il delta è volutamente STRETTO — il corpus è
// tecnico e le due varianti coincidono quasi ovunque (nessun 'ordenador',
// nessun 'disco duro' divergente, forme di cortesia già in 'usted').
// Sidecar anti-stantie: ../meta/system.es-MX.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './system'

export const esMX: DeepPartial<typeof enUS> = {}
